export default __webpack_public_path__ + "static/media/activate-blog-icon.cba0da25.svg";